export const GET_ROOMS_REQUEST = "ROOM.GET_ROOMS_REQUEST";
export const GET_ROOMS_SUCCESS = "ROOM.GET_ROOMS_SUCCESS";
export const GET_ROOMS_FAILURE = "ROOM.GET_ROOMS_FAILURE";

export const CREATE_ROOM_REQUEST = "ROOM.CREATE_ROOM_REQUEST";
export const CREATE_ROOM_SUCCESS = "ROOM.CREATE_ROOM_SUCCESS";
export const CREATE_ROOM_FAILURE = "ROOM.CREATE_ROOM_FAILURE";

export const SET_ROOM_STAT_REQUEST = "ROOM.SET_ROOM_STAT_REQUEST";
export const SET_ROOM_STAT_SUCCESS = "ROOM.SET_ROOM_STAT_SUCCESS";
export const SET_ROOM_STAT_FAILURE = "ROOM.SET_ROOM_STAT_FAILURE";

export const DELETE_ROOM_REQUEST = "ROOM.DELETE_ROOM_REQUEST";
export const DELETE_ROOM_SUCCESS = "ROOM.DELETE_ROOM_SUCCESS";
export const DELETE_ROOM_FAILURE = "ROOM.DELETE_ROOM_FAILURE";

export const EDIT_ROOM_REQUEST = "ROOM.EDIT_ROOM_REQUEST";
export const EDIT_ROOM_SUCCESS = "ROOM.EDIT_ROOM_SUCCESS";
export const EDIT_ROOM_FAILURE = "ROOM.EDIT_ROOM_FAILURE";
